import React from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";
import Footer from "./Footer";

export default function Home() {
  return (
    <section className="home">
      <Navbar />
      <Hero />
      <Footer />
    </section>
  );
}
